/* eslint-disable linebreak-style */
define('AwaLabs.AutoSlider', [
    'Configuration',
    'Backbone',
    'jQuery',
    'underscore'
], function AwaLabsAutoSlider(
    Configuration,
    Backbone,
    jQuery,
    _
) {
    'use strict';

    Configuration = Configuration.Configuration || Configuration;

    var layoutMountKey = 'awaLabsAutoSliderMounted';
    var sliderDataKey = 'awaLabsAutoSliderInstance';
    var viewCleanupKey = 'awaLabsAutoSliderCleanupBound';

    function canInitializeSlider($slider) {
        return $slider &&
            $slider.length &&
            typeof $slider.bxSlider === 'function' &&
            !_.oldIE() &&
            !(typeof SC !== 'undefined' && SC.isPageGenerator && SC.isPageGenerator());
    }

    function destroySlider($slider) {
        var slider = $slider && $slider.data(sliderDataKey);

        if (slider && typeof slider.destroySlider === 'function') {
            slider.destroySlider();
        }
        if ($slider && $slider.length) {
            $slider.removeData(sliderDataKey);
        }
    }

    function destroyViewSliders(view) {
        if (!view || typeof view.$ !== 'function') {
            return;
        }

        _.each(view.$('[data-autoslider]'), function eachSlider(slider) {
            destroySlider(jQuery(slider));
        });
    }

    function bindViewCleanup(view) {
        if (!view || typeof view.on !== 'function' || view[viewCleanupKey]) {
            return;
        }

        view[viewCleanupKey] = true;
        view.on('beforeViewRender beforeCompositeViewRender destroy', function cleanupAutoSliders() {
            destroyViewSliders(view);
        });
    }

    function initializeSlider($slider) {
        var options = Configuration.bxSliderDefaults || {};
        var slider;

        if (!canInitializeSlider($slider)) {
            return;
        }

        try {
            options = $slider.data('autoslideroptions') || options;
        } catch (e) {
            options = Configuration.bxSliderDefaults || {};
        }

        slider = $slider.data(sliderDataKey);
        if (slider) {
            if (typeof slider.reloadSlider === 'function') {
                slider.reloadSlider(options);
            }
            return;
        }

        // Another component may own this slider already. A second bxSlider call
        // would nest wrappers and bind duplicate document/window handlers.
        if ($slider.parent().hasClass('bx-viewport')) {
            return;
        }

        slider = $slider.bxSlider(options);
        $slider.data(sliderDataKey, slider);
    }

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getLayout();

            if (!layout || layout[layoutMountKey]) {
                return;
            }
            layout[layoutMountKey] = true;

            function getCurrentView() {
                return layout && layout.getCurrentView
                    ? layout.getCurrentView()
                    : layout && layout.currentView;
            }

            function bindCMS(cms) {
                var onContentSet;

                if (!cms || typeof cms.on !== 'function' || layout.awaLabsAutoSliderCMSBound) {
                    return;
                }
                layout.awaLabsAutoSliderCMSBound = true;

                onContentSet = function onContentSet() {
                    var currentView = getCurrentView();

                    // CMS can reuse the current view during content replacement.
                    // Tear down only instances owned by this extension before the
                    // deferred pass sees the newly inserted content.
                    destroyViewSliders(currentView);
                    _.defer(function onDefer() {
                        currentView = getCurrentView();
                        bindViewCleanup(currentView);

                        var $sliders = (currentView && currentView.$('[data-autoslider]')) || [];
                        _.each($sliders, function eachSlider(slider) {
                            initializeSlider(jQuery(slider));
                        });
                    });
                };

                cms.on('page:content:set', onContentSet);
                layout.once('destroy', function removeAutoSliderListeners() {
                    cms.off('page:content:set', onContentSet);
                    Backbone.off('cms:loaded', bindCMS);
                    destroyViewSliders(getCurrentView());
                    delete layout[layoutMountKey];
                    delete layout.awaLabsAutoSliderCMSBound;
                });
            }

            Backbone.once('cms:loaded', bindCMS);
            if (typeof CMS !== 'undefined') {
                bindCMS(CMS);
            }
        }
    };
});
